import { render, staticRenderFns } from "./KategoriDetail.vue?vue&type=template&id=085aed57&"
import script from "./KategoriDetail.vue?vue&type=script&lang=js&"
export * from "./KategoriDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports